import { useFormikContext } from 'formik';
import React from 'react';

// eslint-disable-next-line import/no-cycle
import { FormErrors } from 'common/components/forms';
import { useLocalization } from 'redux/localization/utils/hooks';

const CustomFormErrors = () => {
  const { errors, touched } = useFormikContext();
  const { t } = useLocalization();

  let errorMessage;
  if (errors.customerConfirmedAge && touched?.customerConfirmedAge) {
    errorMessage = `${t('general.errorMessages.invalidSavedAddress')} ${
      errors.customerConfirmedAge
    }`;
  }
  if (touched?.countryCode && errors.countryCode) {
    errorMessage = `${t('checkout.delivery.shipCountryErrorMessage')} `;
  }
  if (touched?.stateCode && errors.stateCode) {
    errorMessage = `${t('checkout.delivery.shipStateErrorMessage')} `;
  }
  if (touched?.zipCode && errors.zipCode) {
    errorMessage = `${t('checkout.delivery.shipStateErrorMessage')} `;
  }

  return <FormErrors error={errorMessage} />;
};

export default CustomFormErrors;
